import React from 'react';
import logonegro from '../../assets/images/logonegro.svg';

interface DashboardInitialLoadingProps {
  isVisible: boolean;
  loadingMessage?: string;
}

const DashboardInitialLoading: React.FC<DashboardInitialLoadingProps> = ({
  isVisible,
  loadingMessage = "Loading your wallet data..."
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-white/95 backdrop-blur-sm flex items-center justify-center">
      <div className="flex flex-col items-center space-y-6">
        {/* Logo */}
        <div className="w-48 h-48 mb-4">
          <img
            src={logonegro}
            alt="Belobaba"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Spinner animado */}
        <div className="relative">
          <div className="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
          <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-b-blue-400 rounded-full animate-spin" style={{ animationDelay: '0.2s' }}></div>
        </div>

        {/* Mensaje de carga */}
        <div className="text-center">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">
            Please wait
          </h3>
          <p className="text-gray-600 max-w-sm">
            {loadingMessage}
          </p>
          <div className="mt-4 flex justify-center space-x-1">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>

        {/* Texto adicional */}
        <p className="text-sm text-gray-500 text-center max-w-md">
          We're loading your wallets, balances, and account information. This may take a few moments.
        </p>
      </div>
    </div>
  );
};

export default DashboardInitialLoading;